import 'core-js/es6/map';
import 'core-js/es6/set';
import './scss/index.scss';

import { applyMiddleware, compose, createStore } from 'redux';

import App from './js/App';
import { LicenseManager } from 'ag-grid-enterprise';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import config from './js/config/config';
import rootReducer from './js/common/reducers';
import thunk from 'redux-thunk';
import unauthorizedMiddleware from './js/common/middleware/authorization-middleware';

LicenseManager.setLicenseKey( config.AGGRID_KEY );

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    { appConfig: config },
    composeEnhancers( applyMiddleware( thunk.withExtraArgument( config ), unauthorizedMiddleware ) )
);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById( 'root' )
);
